import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
import custom from '@/f1/custom';

import { api } from '@/f1/service';
import Language from './language';


const _i18n_data = {
  username: {
    EN : () => `Username required.`,
    KO : () => `아이디를 입력하세요.`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};
const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', opt : { },
})

export default {
  components : { DatePicker, Language },
  data: () => {
    return {
      custom,
      selected: 1,
      so : default_opt()
    }
  },
  computed: {
    i18n_data() { return _i18n_data; },
    fields() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'is_alive', label: 'Usage status', sortable: false },
        { key: 'hash', label: 'Hash', sortable: false, thStyle: 'width: 40%' },
        { key: 'cause', label: 'Description', sortable: false },
        { key: 'created_at', label: 'Date', sortable: false },
        // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%' },
      ]
    },
    fields_ko() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'is_alive', label: '사용 여부', sortable: false },
        { key: 'hash', label: '해시', sortable: false, thStyle: 'width: 40%' },
        { key: 'cause', label: '설명', sortable: false },
        { key: 'created_at', label: '일시', sortable: false },
        // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%' },
      ]
    },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; }
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      var search = { target: 'hash', cmd : 'list',limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [{name : 'is_del', value: false, op : '='}], or: [], sort: [{ name: 'id', op : 'desc'}] } }
      if(ctx.sortBy) { this.search.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim()) { search.body.and = [ { name : 'code', value : `%${this.so.sv}%`, op : 'like' } ] }
      if(so.sk && so.sv) {
        const value = so.sv.replace(/\*/g, '%');
        for(let key of so.sk.split(',')) {
          search.body.or.push({"name": key, "value": `%${value}%`, "op": 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'is_alive' : search.body.and.push({name: 'is_alive', value: value, op: '=' }); break;
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          // default: this.search.body.and.push({name: key, value: value, op: /[%\*]/.test(value) ? 'like' : '=' }); break;
        }
      }

      return api.wsfinder.WSFinder(search).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    detail: function(item) { this.$router.push(`hash/${item.id}`); },
  	hideList: function(e) { this.show = !e; console.log('hash.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') }
  },
  created: function() {   console.log('hash.list.vue', 'created'); },
  destroyed: function() { console.log('hash.list.vue', 'destroyed'); },
  mounted: function() { console.log('hash.list.vue', 'mounted'); },
}
